<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title"><a id="page_2"></a><span class="bold">Prologue</span></h2>
<p class="noindent">‘Does Chris like Scouse?’ Irene’s mother enquired, in a manner which I later came to recognise as shyness, but which at the time suggested I could not be trusted to speak for myself.</p>
<p class="indent">‘Yes he does’, Irene replied, continuing to ignore me and finish her makeup. Around me the Johnson family, a couple of passing friends and those who aspired to friendship, munched on Margaret Johnson’s lashings of lamb stew, which with the addition of a few secret ingredients, was transformed into Scouse; indeed, by repute, the best Scouse in the Walton area of Liverpool. The origins of Scouse go back many years to Lobscaus, a Nordic sailors’ dish made from fish and vegetables, which was transmogrified over the centuries by Liverpool seamen into something more akin to Irish Stew. I sat somewhat self-consciously on the edge of the sofa, plate perched on lap, totally inept in the art of eating from a plate balanced so precariously, anxiously looking for a flat surface to avoid what I saw as an inevitable and humiliating catastrophe.</p>
<p class="indent">Sensing my plight, Mrs Johnson made room on the tiny parlour table, and furnishing me with a knife to supplement my fork, I was squeezed into a place that became mine for the next few years. I had arrived and, it seemed, been accepted by the main authority in the household, and despite the obvious suspicion and mistrust by some, I was there to stay. In consequence, Scouse, the dish that gives Liverpudlians their name, had become part of my staple diet, at least when I was visiting Irene in 29 Appleton Road, Walton, Liverpool; one of many terraced houses in a congested, working-class area of the city, but conveniently close to Everton football ground. How my life was to change!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Prologue.vue?46b0d59c